import { useEffect, useRef } from "react";
import QRCodeStyling from "qr-code-styling";
import { DocumentData } from "firebase/firestore";

export function EventQR({ event }: { event: DocumentData | null }) {
  const qrCode = new QRCodeStyling({
    width: 370,
    height: 370,
    data: `${window.location.origin}/events/${event?.id ?? ""}`,
    image:
      "https://framerusercontent.com/images/82QEExZOqdqTajMXxOKxq2WI2yM.png",
    dotsOptions: {
      color: "#000",
      type: "dots", // This is the key line — makes modules circular
    },
    backgroundOptions: {
      color: "#fff",
    },
    imageOptions: {
      crossOrigin: "anonymous",
      margin: 20,
      saveAsBlob: true,
    },
    cornersSquareOptions: {
      type: "dot",
    },
    cornersDotOptions: { type: "dot" },
  });

  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      qrCode.append(ref.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadQRCode = async () => {
    qrCode.download({ name: `${event?.title}-qr`, extension: "png" });
  };
  return (
    <>
      <div
        className="modal fade event-qr-modal"
        id="event-qr-modal"
        tabIndex={-1}
        aria-labelledby="event-qr-modal-label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="event-qr-modal-label">
                Event QR
              </h1>

              <button
                type="button"
                className="bttn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="bi bi-x-circle"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="event-qr-modal__qr-code-container" id="qr-code">
                <div className="event-qr-modal__qr-code" ref={ref} />
              </div>
              <button onClick={downloadQRCode}>Download</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
